import React, { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import axios from "axios";
import { useAuth } from '../../../../../../../context/AuthContext';
import { useParams } from 'react-router-dom';
import Swal from 'sweetalert2'
import { useNavigate } from "react-router-dom";
import GeneralRequestHelper from '../../../../../../../Helpers/GeneralRequestHelper';
import SubmitButton from '../UI/SubmitButton';
import InfoInput from '../UI/InfoInput';
import CorrectAnswer from '../UI/CorrectAnswer';
import QuestionTextInput from '../UI/QuestionTextInput';
import AddContentQuestion from '../UI/AddContentQuestion';
import Tag from '../UI/Tag';
import TitleArea from '../UI/TitleArea';
import { API_BASE_URL } from "../../../../../../../Helpers/apiConfig";

const Write = () => {
    const { t } = useTranslation()
    const { user } = useAuth();
    const params = useParams()
    const navigate = useNavigate();
    const [msg, setMsg] = useState([]);
    const [imagePath, setImagePath] = useState(null);
    const [videoPath, setVideoPath] = useState(null);
    const [soundPath, setSoundPath] = useState(null);
    const [data, setData] = useState([]);

    const handletype4 = async (e) => {
        var question;
        let questiontext = document.getElementById("questionText").value;
        if (imagePath) {
            question = {
                type: "image",
                url: imagePath,
                text: questiontext
            }
        }
        else if (soundPath) {
            question = {
                type: "sound",
                url: soundPath,
                text: questiontext
            }
        }
        else if (videoPath) {
            question = {
                type: "video",
                url: videoPath,
                text: questiontext
            }
        }
        else {
            question = {
                type: "text",
                url: "",
                text: questiontext
            }
        }
        var answertext = document.getElementById("answerText4").value;
        var answer = document.getElementById("correctAnswer").value;
        var info = document.getElementById("infoBoxText").value;
        e.preventDefault();
        var stringquestion = JSON.stringify(question)
        try {

            var questionn = {
                isDeleted: data.isDeleted,
                tagId: document.getElementById("tagId").value,
                sortId: data.sortId,
                contentType: "write",
                subjectId: params["subject"],
                contentStr: stringquestion,
                detail: answertext,
                notfyText: info,
                answer: answer,
                id: params['sort']
            }
            await GeneralRequestHelper("/api/admin/ContentManager/Update", "post", questionn, user.token).then(res => {
                if (res.status === 200) {
                    if (res.data['success']) {
                        Swal.fire({
                            title: "Başırılı!",
                            icon: "success",
                            confirmButtonText: `Soru listesi sayfasına Dön`,
                            timer: 5000,
                        }).then(() => {
                            navigate("/admin/questionlist");
                        });
                    }
                    else {
                        setMsg(res.data['message']);
                    }
                }
                else {
                    setMsg("Beklenmedik Bir Hata Oluştu. Tekrar Deneyiniz.");
                }
            });
        } catch (err) {
            alert(err.message)
            setMsg(err.message);
        }
    }
    const getQuestion = async () => {
        try {
            const headerss = {
                "accept": "*/*",
                'Content-Type': 'application/json',
                'Access-Control-Allow-Credentials': 'false',
                'Authorization': 'Bearer ' + user.token
            }
            let url = `${API_BASE_URL}/admin/ContentManager/GetById`;
            await axios({
                method: 'GET',
                url: url,
                headers: headerss,
                params: {
                    id: params["sort"]
                }
            }).then(res => {
                if (res.status === 200) {
                    if (res.data['success']) {
                        setData(res.data['data'])
                    }
                    else {
                        setMsg(res.data['message']);
                    }
                }
                else {
                    setMsg("Beklenmedik Bir Hata Oluştu. Tekrar Deneyiniz.");
                }
            });
        }
        catch (err) {
            setMsg(err?.message || "Bir hata oluştu");
        }
    }
    useEffect(() => {
        getQuestion();
    }, []);
    return (
        <div>
            <div>
                <TitleArea msg={msg} text={"Yazma Oluşturma Sayfası"} />
                <Tag />
                <AddContentQuestion setMsg={setMsg} setImagePath={setImagePath} setVideoPath={setVideoPath} setSoundPath={setSoundPath} />
                <hr />
            </div>
            <form onSubmit={handletype4} >
                <QuestionTextInput />
                <div class="mb-3">
                    <label for="answerText4" class="form-label"><b>{t("answerText")}</b></label><br /><i>kelimenin olacağı yere altçizgi koyunuz. Örn: what is _ name my name _ ahmet.</i>
                    <textarea class="form-control" id="answerText4" required />
                </div>

                <CorrectAnswer text="örn: 'your,is' (ilk kelime 1. alt çizgi yerine yazılacak kelime, ikinci kelime 2. alt çizgi yerine yazılacak kelime. her bir kelimeyi virgül ile ayırın. KAÇ ADET ALT ÇİZGİ VARSA O KADAR KELİME OLMALI)" />
                <InfoInput />
                <SubmitButton />
            </form>

        </div>
    );
};

export default Write;